import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import Home from './views/Home.vue'
import AboutUs from './views/AboutUs.vue'
import Services from './views/Services.vue'
import Clients from './views/Clients.vue'
import Community from './views/Community.vue'
import ExecutiveView from './views/views/executive-view.vue'
import HrView from './views/views/hr-view.vue'
import ItView from './views/views/it-view.vue'
import Budget from './views/views/budget-view.vue'
import Contracts from './views/views/contracts-view.vue'
import Facilities from './views/views/facilities-view.vue'
import Performance from './views/views/performance-view.vue'
import Program from './views/views/program-view.vue'
import Admin from './views/views/admin-view.vue'
import Comparables from './views/views/comparables-view.vue'
import Travel from './views/views/travel-view.vue'
import Grants from './views/views/grants-view.vue'
import Blog from './views/blog/blog.vue'
import WhyChooseHubzoneCertifiedCompanies from './views/blog/Why-Choose-Hubzone-Certified-Companies.vue'
import QlikSenseMashups from './views/blog/Qlik-Sense-Mashups.vue'
import WhyQlikSense from './views/blog/Why-Qlik-Sense.vue'

Vue.use(Router)

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: AboutUs
    },
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      path: '/community',
      name: 'community',
      component: Community
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/executive-view',
      name: 'executive-view',
      component: ExecutiveView
    },
    {
      path: '/hr-view',
      name: 'hr-view',
      component: HrView
    },
    {
      path: '/it-view',
      name: 'it-view',
      component: ItView
    },
    {
      path: '/budget-view',
      name: 'budget-view',
      component: Budget
    },
    {
      path: '/contracts-view',
      name: 'contracts-view',
      component: Contracts
    },
    {
      path: '/facilities-view',
      name: 'facilities-view',
      component: Facilities
    },
    {
      path: '/performance-view',
      name: 'performance-view',
      component: Performance
    },
    {
      path: '/program-view',
      name: 'program-view',
      component: Program
    },
    {
      path: '/admin-view',
      name: 'admin-view',
      component: Admin
    },
    {
      path: '/comparables-view',
      name: 'comparables-view',
      component: Comparables
    },
    {
      path: '/travel-view',
      name: 'travel-view',
      component: Travel
    },
    {
      path: '/grants-view',
      name: 'grants-view',
      component: Grants
    },
    {
      path: '/Why-Choose-Hubzone-Certified-Companies',
      name: 'hubzone',
      component: WhyChooseHubzoneCertifiedCompanies
    },
    {
      path: '/Qlik-Sense-Mashups',
      name: 'mashups',
      component: QlikSenseMashups
    },
    {
      path: '/Why-Qlik-Sense',
      name: 'mashups',
      component: WhyQlikSense
    }
  ]
})

Vue.use(VueAnalytics, {
  id: 'UA-149935666-1',
  router
})

router.beforeEach((to, from, next) => {
  switch(to.path) {
    case '/home':
      window.location.href = 'https://www.fedsight.com'
      break;
    case '/executive-view/':
      window.location.href = 'https://www.fedsight.com/executive-view'
      break;
    case '/hr-view/':
      window.location.href = 'https://www.fedsight.com/hr-view'
      break;
    case '/it-view/':
      window.location.href = 'https://www.fedsight.com/it-view'
      break;
    case '/budget-view/':
      window.location.href = 'https://www.fedsight.com/budget-view'
      break;
    case '/contracts-view/':
      window.location.href = 'https://www.fedsight.com/contracts-view'
      break;
    case '/facilities-view/':
      window.location.href = 'https://www.fedsight.com/facilities-view'
      break;
    case '/performance-view/':
      window.location.href = 'https://www.fedsight.com/performance-view'
      break;
    case '/program-view/':
      window.location.href = 'https://www.fedsight.com/program-view'
      break;
    case '/admin-view/':
      window.location.href = 'https://www.fedsight.com/admin-view'
      break;
    case '/comparables-view/':
      window.location.href = 'https://www.fedsight.com/comparables-view'
      break;
    case '/travel-view/':
      window.location.href = 'https://www.fedsight.com/travel-view'
      break;
    case '/grants-view/':
      window.location.href = 'https://www.fedsight.com/grants-view'
      break;
    default:
      next()
  }
})

export default router